import React from 'react';
import { Android, o_i_take_me_there } from '../../../utils/DictionaryManagementUtils';
import EnableKeyboardAndroidFP from '../FullPagesComponents/OnBoarding/EnableKeyboardAndroidFP';
import SelectKeyboardAndroidFP from '../FullPagesComponents/OnBoarding/SelectKeyboardAndroidFP';
import EnableKeyboardIosFP from '../FullPagesComponents/OnBoarding/EnableKeyboardIosFP';
import SelectKeyboardIosFP from '../FullPagesComponents/OnBoarding/SelectKeyboardIosFP';
import SuccessSelectedKeyboardFP from '../FullPagesComponents/OnBoarding/SuccessSelectedKeyboardFP';
import SimulatorsViewerArrangement from '../FullPagesComponents/SimulatorsViewerArrangement';
import SuccessSelectedWithOutKeyboardFP from '../FullPagesComponents/OnBoarding/SuccessSelectedWithOutKeyboardFP';

const InstructionsDF = ({
  globJSON,
  simPlatform,
  slideshowRefs = null,
  language,
}) => {
  const { instructions } = globJSON.configurations.onboarding;
  return (
    <SimulatorsViewerArrangement>
      {simPlatform === Android
        ? (
          <EnableKeyboardAndroidFP
            globJSON={globJSON}
            language={language}
            simPlatform={simPlatform}
            slideshowRefs={slideshowRefs}
            withOutTitle
          />
        ) : (
          <EnableKeyboardIosFP
            globJSON={globJSON}
            language={language}
            simPlatform={simPlatform}
            slideshowRefs={slideshowRefs}
            withoutTitle
            btnInputText={o_i_take_me_there}
          />
        )}
      {simPlatform === Android
        ? (
          <SelectKeyboardAndroidFP
            globJSON={globJSON}
            simPlatform={simPlatform}
            slideshowRefs={slideshowRefs}
          />
        )
        : (
          <SelectKeyboardIosFP
            globJSON={globJSON}
            simPlatform={simPlatform}
            slideshowRefs={slideshowRefs}
          />
        )}
      {instructions.enable_keyboard_with_string
        ? (
          <SuccessSelectedKeyboardFP
            globJSON={globJSON}
            simPlatform={simPlatform}
            slideshowRefs={slideshowRefs}
          />
        ) : (
          <SuccessSelectedWithOutKeyboardFP
            globJSON={globJSON}
            simPlatform={simPlatform}
            slideshowRefs={slideshowRefs}
          />
        )}
    </SimulatorsViewerArrangement>
  );
};

export default InstructionsDF;
